// #612: „Löschen“ für mehrere ausgewählte Dateien – Rückfrage, in den Papierkorb, Meldung mit „Rückgängig“.
import { useState } from 'react';
import { Trash } from '@phosphor-icons/react';
import { BestaetigenDialog, ImmoButton, type ToastAktion } from '../immobilien/ui';
import { ausPapierkorb, inPapierkorb, papierkorbText, type PapierkorbEintrag } from '../../lib/dokumente/papierkorb';

export function PapierkorbKnopf({ eintraege, zeige, onFertig }: {
  eintraege: readonly PapierkorbEintrag[];
  zeige: (text: string, fehler?: boolean, aktion?: ToastAktion) => void;
  /** nach dem Löschen bzw. Wiederherstellen (Liste neu laden, Auswahl leeren); ids = Drive-IDs */
  onFertig: (art: 'geloescht' | 'wieder', driveIds: string[]) => void;
}) {
  const [frage, setFrage] = useState(false);
  const [laeuft, setLaeuft] = useState(false);
  const n = eintraege.length;
  const mitFreigabe = eintraege.some(e => e.dokumentId);

  const loeschen = async () => {
    setLaeuft(true);
    const r = await inPapierkorb(eintraege);
    setLaeuft(false); setFrage(false);
    onFertig('geloescht', r.ok.map(e => e.driveId));
    zeige(papierkorbText(r), r.fehler.length > 0, r.ok.length ? {
      label: 'Rückgängig',
      onClick: () => { void ausPapierkorb(r.ok).then(k => { zeige(k === 1 ? 'Datei wiederhergestellt' : `${k} Dateien wiederhergestellt`); onFertig('wieder', r.ok.map(e => e.driveId)); }); },
    } : undefined);
  };

  return (
    <>
      <ImmoButton art="bad" icon={Trash} onClick={() => setFrage(true)} disabled={!n}>Löschen</ImmoButton>
      {frage && (
        <BestaetigenDialog titel={n === 1 ? 'Datei löschen?' : `${n} Dateien löschen?`} bestaetigenLabel="In den Papierkorb" icon={Trash} laeuft={laeuft}
          text={`${n === 1 ? 'Die Datei wandert' : `Die ${n} Dateien wandern`} in den Papierkorb von Google Drive und lässt sich direkt danach mit „Rückgängig“ zurückholen.${mitFreigabe ? ' Portal-Freigaben werden dabei entfernt.' : ''}`}
          onBestaetigen={() => { void loeschen(); }} onAbbrechen={() => setFrage(false)} />
      )}
    </>
  );
}
